import { render, staticRenderFns } from "./JobPreviewContentSub.vue?vue&type=template&id=bbcbecca&scoped=true"
import script from "./JobPreviewContentSub.vue?vue&type=script&lang=js"
export * from "./JobPreviewContentSub.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewContentSub.vue?vue&type=style&index=0&id=bbcbecca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcbecca",
  null
  
)

export default component.exports